import { Navigate, useParams } from "react-router";
import ObjectDetailsPage from "../../../entityFields/ObjectDetailsPage";

const FundInvestmentDetailsPage = () => {
  const { id } = useParams();

  if (!id) {
    return <Navigate to=".." />;
  }

  return <ObjectDetailsPage objectId={id} objectType="FundInvestment" backButtonPath=".." />;
};

export default FundInvestmentDetailsPage;
